import React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import isValidFilename from 'valid-filename';

export default function FormDialog(props) {
  const [open, setOpen] = React.useState(false);
  const [foldername, setFoldername] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        color="primary"
        variant="outlined"
        component="span"
        onClick={handleClickOpen}
        startIcon={<CreateNewFolderIcon />}
      >
        CREATE DIRECTORY
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        maxWidth={"md"}
        fullWidth
      >
        <DialogTitle id="form-dialog-title">Add Folder</DialogTitle>
        <DialogContent>
          {/* <DialogContentText>
            
          </DialogContentText> */}
          <TextField
            error={errorMessage.length}
            autoFocus
            margin="dense"
            id="folder-name"
            label="Name of new folder"
            type="text"
            value={foldername}
            helperText={errorMessage}
            onChange={(e) => {
              if (e.target.value.length === 0) {
                setErrorMessage("Required");
              } else if (!isValidFilename(e.target.value)) {
                setErrorMessage("Invalid Characters");
              } else {
                setErrorMessage("");
              }
              setFoldername(e.target.value);
            }}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={(e) => {
              handleClose();
              props.onConfirm(foldername);
              setFoldername("");
            }}
            color="primary"
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
